// extracted by mini-css-extract-plugin
module.exports = {"light":"MainOrder_light__QWeN2","lightColor":"MainOrder_lightColor__fJMOQ","lightBgc":"MainOrder_lightBgc__jBAnR","lightOrange":"MainOrder_lightOrange__HWuPW"};